export class ENV {
  static Environment = '';
  static YotpoApiEndpoint = '';
  static ErrorPageUrl = '';
  static RedcrossUrl = '';
  static SegmentKey = '';
  static RedcrossSnippetVersion = '';
  static YotpoB2bEndpoint = '';
  static LoginServiceUrl = 'https://login.yotpo.com/';
  static SuiteDomain = '';
  static YotpoNewB2bEndpoint = '';
  static ReviewsAppDomain = '';
  static YotpoAccountsCompleteRegistrationUrl = '';
  static YotpoAccountsSignupUrl = '';
  static YotpoAgencyPartner = '';
  static AllowedRedirectHosts = ('my.yotpo.com,yap.yotpo.com,w2.yotpo.com,' +
  'b2b.yotpo.com,dev-my.yotpo.com,dev-yap.yotpo.com,dev-w2.yotpo.com,dev-b2b.yotpo.com,staging-my.yotpo.com,' +
  'staging-yap.yotpo.com,staging-w2.yotpo.com,staging-b2b.yotpo.com');
  static ReCaptchaSiteKey = '';
  static ShowCaptcha = true;
  static RollbarAccessToken = '';
  static launchDarklyClientId = '';
  static launchDarklyEnabled = false;
  static LogLevel = 'INFO';
  static UseAccountSystemAsDefault = true;
  static isLocalStorageFallback = true;
  static YotpoDomain = '.yotpo.com';
  static Auth0Domain = 'auth.yotpo.com';
  static Auth0ClientId = 'V6RT7uQKK99dfOM9ao67xqEjulZkn2tK';
  static Auth0Audience = 'api.yotpo.com';
  static BackofficeUrl = 'https://backoffice.yotpo.com';
  static YotpoLoyaltyUrl: 'https://loyalty.yotpo.com';
  static LoginPermission = 'reviews:stores:login';
  static ReviewsEmbeddedAppHandle = 'yotpo-social-reviews';
}

(function () {
  Object.assign(ENV, window['_env']);
}());
